import { styled, Box } from "@mui/material";

export const FlowBox = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  flexGrow: 1,
  height: "100%",
}));
